@if (!isEmbeddedView) {
<div class="sidenav">
  <div class="header">
    @if (isShow) {
    <div class="side-data cursor-pointer" (click)="goToHome()">
      <img src="/assets/images/sidenav/jio.svg" alt="logo" />
      <span>Loyalty</span>
    </div>
    }
    <button
      [ngClass]="{ 'm-left': isShow }"
      class="toggle-btn"
      mat-mini-fab
      color="primary"
      (click)="toggleMe()"
      aria-label="Example fab with a heart icon"
    >
      @if (isShow) {
      <mat-icon>keyboard_arrow_left</mat-icon>
      } @if (!isShow) {
      <mat-icon>keyboard_arrow_right</mat-icon>
      }
    </button>
  </div>
  <div class="navigation" #sidebarMiddle>
    @for (c of topCategories; track c) { @if (c.canShow) {
    <ng-container
      [ngTemplateOutlet]="
        c.subMenu && c.subMenu.length ? multipleNav : simplTem
      "
      [ngTemplateOutletContext]="{ nav: c, openState: c.isExpand }"
    >
    </ng-container>
    } }
  </div>
  <div class="footer">
    @for (c of bottomCategories; track c) {
    <ng-container
      [ngTemplateOutlet]="
        c.subMenu && c.subMenu.length ? multipleNav : simplTem
      "
      [ngTemplateOutletContext]="{ nav: c, openState: c.isExpand }"
    >
    </ng-container>
    }
    <a matTooltip="{{ !isShow ? 'Logout' : '' }}" (click)="logout()">
      <img src="/assets/images/sidenav/power-off.svg" alt="logout" />
      @if (isShow) {
      <span>Logout</span>
      }
    </a>
  </div>
</div>
}

<ng-template #simplTem let-c="nav">
  <a
    matTooltip="{{ !isShow ? c.name : '' }}"
    routerLinkActive="active"
    (click)="closeAllExpansionPanels()"
    [routerLink]="c.link"
    #rla="routerLinkActive"
    [ngClass]="{ 'cat-width': isShow }"
  >
    <img
      src="assets/images/sidenav/{{ rla.isActive ? c.iconActive : c.icon }}.svg"
    />
    @if (isShow) {
    <span>{{ c.name }}</span>
    }
  </a>
</ng-template>

<ng-template #multipleNav let-c="nav" let-accordionOpenState="openState">
  <mat-accordion (click)="handleAccordion(c)">
    <mat-expansion-panel
      [expanded]="accordionOpenState"
      (afterExpand)="onAccordionExpanded(c)"
      #panel
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <a
            [ngClass]="{ 'cat-width': isShow }"
            matTooltip="{{ !isShow ? c.name : '' }}"
          >
            <img src="assets/images/sidenav/{{ c.icon }}.svg" />
            @if (isShow) {
            <span>{{ c.name }}</span>
            }
          </a>
        </mat-panel-title>
      </mat-expansion-panel-header>
      @for (subM of c.subMenu; track subM) { @if (subM.canShow !== false) {
      <a
        [class.active]="isRouteActive(subM)"
        [routerLink]="subM.link"
        [ngClass]="{ 'cat-width': isShow }"
        >@if (isShow) {
        <span class="sub-menu">{{ subM.name }}</span>
        }</a
      >
      } }
    </mat-expansion-panel>
  </mat-accordion>
</ng-template>
